import apachehttp from"./apachehttp";export default{info:{key:"java8",title:"Java8+Apache",extname:".java",default:"apachehttp"},apachehttp:apachehttp};
//# sourceMappingURL=index.js.map